import { Box } from '@mui/material';
import { HeaderCellProps } from '../types';

export const TeamIdHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return (
    <Box
      sx={{
        textAlign: 'left',
      }}
    >
      ID
    </Box>
  );
};
